<button
    mat-raised-button
    class="primary-btn rounded button2 ml-2"
    (click)="verification()"
    *ngIf="boton"
>
    <span class="mat-button-wrapper">
        Casos por Aprobar
    </span>
</button>
